import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import Instructor from './section-components/information-technology-courses';
import Footer from './global-components/footer-v2';

const InformationTechnologyCourses = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Information Technology Courses"  />
        <Instructor />
        <Footer />
    </div>
}

export default InformationTechnologyCourses

